<LoaderOverlay :loading="loading"><img :class="imgClass" :src="src" :alt="alt" @load="onLoad" @error="onError"></LoaderOverlay>